import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { WebApiService } from '../service/web-api.service';
import { environment } from '../../environments/environment';

/**
 * 項目チェックサービスの入力クラス
 */
export class CheckItemIn {
  // ユーザ名
  public userId: string;
  // パスワード
  public password: string;
  // 確認用パスワード
  public confirmPassword: string;
  // メールアドレス
  public mailAddress: string;
  // 利用規約
  public consentInfo: string;
  // 生年月日
  public birthdate: string;
  // カナ姓
  public familyName: string;
  // カナ名
  public givenName: string;
  // 電話番号
  public phoneNumber: string;

  constructor() {
    this.userId = null;
    this.password = null;
    this.confirmPassword = null;
    this.mailAddress = null;
    this.consentInfo = null;
    this.birthdate = null;
    this.familyName = null;
    this.givenName = null;
    this.phoneNumber = null;
  }
}

@Injectable()
export class CheckItemService {

  constructor(private webApiServece: WebApiService) { }

  /**
   * 項目チェック
   */
  execAuthCheckItem(checkItemIn: CheckItemIn, isRequiredArray?: string[]): Observable<any> {

    if (isRequiredArray === undefined) {
      isRequiredArray = null;
    }

    const requestParam = {
      user_id: checkItemIn.userId,
      password: checkItemIn.password,
      confirm_password: checkItemIn.confirmPassword,
      mail_address: checkItemIn.mailAddress,
      consent_info: checkItemIn.consentInfo,
      birthdate: checkItemIn.birthdate,
      family_name: checkItemIn.familyName,
      given_name: checkItemIn.givenName,
      phone_number: checkItemIn.phoneNumber,
      isRequiredArray: isRequiredArray
    };
    return this.webApiServece.callAjaxPost(environment.apiServerBaseUrl + '/authorization/check-item', requestParam)
      .map(cfResponse => {
        const data = cfResponse.data;
        // NGの場合はメッセージ、正常の場合はnullを返却
        if (!data.result) {
          return data.messages;
        }
        return null;
      })
      .catch(error => {
        return Observable.throw(error);
      });
  }
}
